import { render, staticRenderFns } from "./ImageMainProduuctCard.vue?vue&type=template&id=00503d3a&"
import script from "./ImageMainProduuctCard.vue?vue&type=script&lang=js&"
export * from "./ImageMainProduuctCard.vue?vue&type=script&lang=js&"
import style0 from "./ImageMainProduuctCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports